import React from "react";
import useTrackWhenVisible from "hooks/useTrackWhenVisible";
import { AnalyticsEvents } from "helpers/analytics/analytics";

const mergeRefs =
  (...refs) =>
  (node) => {
    refs.forEach((ref) => {
      if (!ref) return;
      if (typeof ref === "function") ref(node);
      else ref.current = node;
    });
  };

/** Fires `meet_section_view` once when this block scrolls into view. */
const MeetSectionView = ({
  sectionId,
  as: Tag = "div",
  sectionRef,
  children,
  ...props
}) => {
  const viewRef = useTrackWhenVisible(
    AnalyticsEvents.MEET_SECTION_VIEW,
    {
      label: sectionId,
      location: "meet_page",
    },
    0.35
  );

  return (
    <Tag ref={mergeRefs(viewRef, sectionRef)} {...props}>
      {children}
    </Tag>
  );
};

export default MeetSectionView;
